import { memo, useState } from "react";
import { useAppDispatch } from "../../../../../redux/hooks";
import ActionMenu, {
  ActionMenuItem,
} from "../../../../../components/actionMenu/ActionMenu";
import { ActivePackagesDataInterface } from "../../../../../redux/interfaces/expedition.interface";
import {
  getActivePackages,
  postCancelPackage,
} from "../../../../../redux/api/expedition.api";
import {
  checkEndpointStatus,
  endpointStatus,
} from "../../../../../helpers/apiHelper";
import useRoutesHelper from "../../../../../hooks/useRoutesHelper";

function ActivePackagesActionButtons({
  crudData,
}: {
  crudData: ActivePackagesDataInterface;
}) {
  const dispatch = useAppDispatch();
  const { routeParams } = useRoutesHelper();
  const { idExpeditie } = routeParams;
  const [isLoading, setIsLoading] = useState(false);

  const handleCancelPackage = async () => {
    if (!crudData.id_doctrans_detl || crudData.status !== 0 || isLoading) {
      return;
    }

    setIsLoading(true);
    const resultAction = await dispatch(
      postCancelPackage({
        id_doctrans_detl: crudData.id_doctrans_detl,
      }),
    );

    if (
      checkEndpointStatus(resultAction, postCancelPackage) !==
      endpointStatus.pending
    ) {
      setIsLoading(false);
    }

    if (
      checkEndpointStatus(resultAction, postCancelPackage) ===
        endpointStatus.fulfilled &&
      idExpeditie
    ) {
      dispatch(
        getActivePackages({
          id_doctrans: idExpeditie,
          perPage: 9999,
        }),
      );
    }
  };

  const items: ActionMenuItem[] = [
    {
      id: "cancel-package",
      label: "Anuleaza colet",
      icon: "CANCEL",
      color: "error",
      section: "danger",
      dividerBefore: true,
      loading: isLoading,
      hidden: crudData.status !== 0,
      disabled: !crudData.id_doctrans_detl,
      tooltip: "Anuleaza acest colet.",
      withConfirmationModal: {
        modalTitle: "Anuleaza colet",
        modalSubtitle: `Doriti sa anulati coletul ${crudData.doc_trans}?`,
        modalLeftButtonVariant: "outlined",
        modalRightButtonOnClick: handleCancelPackage,
      },
    },
  ];

  return (
    <ActionMenu
      items={items}
      minItemsForMenu={2}
      title={`AWB ${crudData.doc_trans}`}
      ariaLabel={`Actiuni pentru coletul ${crudData.doc_trans}`}
    />
  );
}

export default memo(ActivePackagesActionButtons);
